<template>
	<div class="container">
		<div class="login">
			<div class="row">
				<div class="col-md-offset-4 col-md-4">
					<div class="form-login" @keyup.enter="login()">
						<h4>Bienvenue</h4>
						<input type="text" v-model="username" class="form-control input-sm chat-input" placeholder="Username" />
						<br>
						<input type="password" v-model="password" class="form-control input-sm chat-input" placeholder="Password" />
						<br>
						<div class="wrapper">
							<span class="group-btn">
								<button :disabled="loginDisabled" @click="login()" class="btn btn-primary btn-md">Login</button>
							</span>
						</div>
						<div class="text-center" style="color:red;margin-top:2%;" v-if="badCredentials">
							La combinaison identifiant/mot de passe rentrée est incorrecte.
						</div>
						<div class="text-center" style="color:red;margin-top:2%;" v-if="accessDenied">
							Vous n'avez plus accès à la ressource demandée<br>
							Essayez de vous reconnecter.
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			currentTemplate:  function() {
				return this.$store.state.admin.currentTemplate;
			},
			accessDenied:  function() {
				return this.$store.state.accessDenied;
			},
			badCredentials:  function() {
				return this.$store.state.badCredentials;
			}
		},
		methods: {
			login() {
				let successCallback = (data) => {
					this.$store.commit('TOKEN_UPDATED', {newToken: data.token, newRefreshToken: data.refresh_token});
					if (data.role == "ADMIN")
						this.$router.push({name: 'TemplateList'});
					else if (data.role == "USER")	{
						this.$store.commit('USER_INSTANCES_UPDATED', data.instances);
						this.$router.push({name: 'InstanceList'});						
					}

				};
				this.$store.dispatch('userLogin', {
					username: this.username,
					password: this.password,
					callbacks: {
						success: successCallback
					}
				});
			}
		},
		data: function()  {
			return {
				username: "",
				password: "",
				loginDisabled: true
			};
		},
		beforeMount: function() {
			let self = this;
			this.$router.onReady(function() {
				self.loginDisabled = false;
			});
		}
	};
</script>

<style>
    .login {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 50%;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

    @import url(https://fonts.googleapis.com/css?family=Roboto:400);
    body {
        background-color:#fff;
        -webkit-font-smoothing: antialiased;
        font: normal 14px Roboto,arial,sans-serif;
    }

    .form-login {
        background-color: #EDEDED;
        padding-top: 10px;
        padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 15px;
        border-color:#d2d2d2;
        border-width: 5px;
        box-shadow:0 1px 0 #cfcfcf;
    }

    h4 {
        border:0 solid #fff;
        border-bottom-width:1px;
        padding-bottom:10px;
        text-align: center;
    }

    .form-control {
        border-radius: 10px;
    }

    .wrapper {
        text-align: center;
    }


</style>
